// src/components/shared/profile-actions/MyProfileActions.tsx

"use client";

import React from "react";
import { Users2, UserRoundCog, Plus } from "lucide-react";

import "./MyProfileActions.css";

type Props = {
  className?: string;
  onEditProfile?: () => void;
  onOpenFriends?: () => void;
  onOpenRequests?: () => void;
};

const MyProfileActions: React.FC<Props> = ({
  className = "",
  onEditProfile,
  onOpenFriends,
  onOpenRequests,
}) => {
  return (
    <div className="mpa">
      <div className={`mpa-row ${className}`}>
        {/* edit profile button */}
        <button
          type="button"
          className="mpa-btn mpa-btn--edit"
          onClick={onEditProfile}
        >
          <UserRoundCog size={14} />
          Edit Profile
        </button>

        {/* friends drawer button */}
        <button
          type="button"
          className="mpa-btn mpa-btn--friends"
          onClick={onOpenFriends}
        >
          <Users2 size={14} />
          Friends
        </button>

        {/* requests button */}
        <button
          type="button"
          className="mpa-btn mpa-btn--requests"
          onClick={onOpenRequests}
          aria-label="Open friend requests"
          title="Open friend requests"
        >
          <Plus strokeWidth={2.5} size={16} />
        </button>
      </div>
    </div>
  );
};

export default MyProfileActions;